var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-result"},[_c('div',{staticClass:"no-cell"},[_c('div',[_c('img',{attrs:{"src":require('../assets/img/empty.png'),"alt":""}})]),_vm._v(" "),_c('div',[_vm._v("数据为空")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71a0236c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ocr-no-result.vue
// module id = null
// module chunks = 